import { JobTypeEnum } from '@tsin-core/states/job-opening/job-opening.types';
import {
  CreateApplicationInput,
  CreateRefenceInput,
  IApplicationDTO,
  IApplicationNoteStep,
  IPoolInput,
  IUploadAvatar,
  IUploadCoverLatter,
  IUploadDocs,
  UpdateApplicationInput,
  UpdateReferenceInput
} from './application.interface';

export class GetAllApplications {
  static readonly type = '[Application] get all';
  constructor(
    public queryParams?: {
      applicationStatus?: string;
      applicationReviewStatus?: string;
      department?: string;
      addedToPool?: boolean;
      jobId?: string;
    }
  ) { }
}

export class GetUserApplications {
  static readonly type = '[Application] Get user all appls';
  constructor(public id: string) { }
}

export class ClearApplication {
  static readonly type = '[Application] Clear all appls';
}

export class SetApplicationPreview {
  static readonly type = '[Application] Set application preview'
  constructor(public payload: boolean) { }
}

export class CreateApplication {
  static readonly type = '[Application] Create';
  constructor(public input: CreateApplicationInput) { }
}
export class SaveApplicationNote {
  static readonly type = '[Application] Save Note';
  constructor(public payload: IApplicationNoteStep) { }
}

export class GetSingleApplication {
  static readonly type = '[Application] get one for update';
  constructor(public id: string) { }
}

export class GetOneApplication {
  static readonly type = '[Application] get one';
  constructor(public id: string) { }
}

export class UpdateApplication {
  static readonly type = '[Application] update';
  constructor(public input: UpdateApplicationInput) { }
}

export class DeleteApplication {
  static readonly type = '[Application] delete one';
  constructor(public id: string) { }
}

export class ReviewApplicationStatus {
  static readonly type = '[Application] review statue';
  constructor(public input: { id: string; applicationReviewStatus: string }) { }
}

export class UserApplication {
  static readonly type = '[Application] single user appls';
  constructor(public payload: IApplicationDTO | null) { }
}

export class ApplicationDepartment {
  static readonly type = '[Application] appl dept';
  constructor(public input: { department: string | undefined }) { }
}

export class SubmitApplication {
  static readonly type = '[Application] submit appl';
  constructor(public input: { id: string }) { }
}

export class UploadAvatar {
  static readonly type = '[Application] upload avatar';
  constructor(public input: IUploadAvatar) { }
}
export class UploadResume {
  static readonly type = '[Application] upload resume';
  constructor(public input: IUploadDocs) { }
}

export class UploadCoverLater {
  static readonly type = '[Application] upload letter';
  constructor(public input: IUploadCoverLatter) { }
}

export class AddApplicationToPool {
  static readonly type = '[Application] add to pool';
  constructor(public input: IPoolInput) { }
}

export class GetPoolApplications {
  static readonly type = '[Application] pool appl';
  constructor(public department: string) { }
}

export class AddApplicationReference {
  static readonly type = '[Application] add reference';
  constructor(public input: CreateRefenceInput) { }
}
export class UpdateApplicationReference {
  static readonly type = '[Application] update reference';
  constructor(public input: UpdateReferenceInput) { }
}

export class GetApplicationReferences {
  static readonly type = '[Application] get reference';
  constructor(public id: string) { }
}

export class SaveReferenceNote {
  static readonly type = '[Application] Save reference note';
  constructor(public payload: { referenceId: string, note: string }) { }
}

export class DeletReference {
  static readonly type = '[Application] delete reference';
  constructor(public id: string) { }
}

export class SendHiringWorkflowEmail {
  static readonly type = '[Application] send hiring workflow email';
  constructor(public input: {
    applicationId: string;
    template: string;
    customMessage?: string;
    attachments?: Array<{ filename: string; content: string; contentType: string }>;
  }) { }
}

export class PreviewHiringWorkflowEmail {
  static readonly type = '[Application] preview hiring workflow email';
  constructor(public input: {
    candidateName: string;
    jobTitle: string;
    template: string;
    customMessage?: string;
  }) { }
}

export class CancelApplication {
  static readonly type = '[Application] cancel application';
  constructor(public id: string) { }
}

export class UpdateApplicationStatus {
  static readonly type = '[Application] Update Status';
  constructor(public payload: { id: string; applicationStatus: string }) { }
}
